import { extraLargeScreen } from 'common/theme'
import useLockedBody from 'hooks/useLockedBody'
import useWindowSize from 'hooks/useWindowSize'
import React, { createContext, useLayoutEffect, useState } from 'react'
import { useBiddingSidePanel } from 'store/useBiddingSidePanelStore'
import shallow from 'zustand/shallow'
export interface ILayoutContext {
  showMenuSidebar: boolean
  setShowMenuSidebar: (value: boolean) => void
  isSticky: boolean
  setIsSticky: (sticky: boolean) => void
}

export const LayoutContext = createContext<ILayoutContext>({} as ILayoutContext)

export const LayoutContextProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const [showMenuSidebar, setShowMenuSidebar] = useState<boolean>(false)
  const [isSticky, setIsSticky] = useState<boolean>(false)
  const { isOpen } = useBiddingSidePanel(
    (state) => ({
      isOpen: state.isOpen
    }),
    shallow
  )
  const { width } = useWindowSize()

  useLayoutEffect(() => {
    if (width >= Number(extraLargeScreen.replace(/\D*/g, ''))) {
      setShowMenuSidebar(false)
    }
  }, [width])

  // Only use the hook for menu sidebar - bidding panel handles its own locking
  useLockedBody(showMenuSidebar || isOpen)

  return (
    <LayoutContext.Provider
      value={{
        showMenuSidebar,
        setShowMenuSidebar,
        isSticky,
        setIsSticky
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}
